<template>
  <AppTwoColumnsSelector
    :items="carTypesAll"
    :value="menuSetting.orderDescription.targetCarType.carTypes"
    :is-show-all-select="true"
    @changeChosenItems="
      menuSetting.orderDescription.targetCarType.carTypes = $event
    "
    available-label="車種一覧"
    chosen-label="設定対象車種"
  />
</template>

<script>
export default {
  name: 'CampaignModalPageAutomobileCarType',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    carTypesAll() {
      return [
        {
          name: '普通乗用車',
          value: 'regular_passenger_car',
        },
        {
          name: '軽乗用車',
          value: 'light_passenger_car',
        },
        {
          name: '貨物車両',
          value: 'truck',
        },
        {
          name: '特殊車両',
          value: 'special_car',
        },
      ]
    },
  },
  methods: {
    validate() {
      return true
    },
  },
}
</script>
